export default function NotFoundPage() {
  <div>Cette page est introuvable</div>;
}
